/**
 * Created by Pavel Kozhin on 28/01/16.
 */

/**
 * LastVisitedHotels component.
 */
define(['underscore',
        'jQuery',
        'library/fcse-component/optionsMixin',
        'library/fcse-request/multiRequestHandler',
        'clientComponents/lazyimage/lazyImage',
        'bootstrap'
    ],
    function(_, $, OptionsMixin, MultiRequestHandler, LazyImage) {

        function getStorage() {
            try {
                var storage = window.localStorage,
                  x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return window.localStorage;
            }
            catch(e) {
                return null;
            }
        }
        /**
         * LastVisitedHotels
         * @param element
         * @param options
         * @constructor
         */
        var LastVisitedHotels = function(element, options) {
            this.topElement = $(element);

            this.element = $('[data-fcse-role="last-visited-hotels-slider-container"]', this.topElement);
            this.requestHandler = new MultiRequestHandler();
            this._lastPageIndex = null;
            this._storage = getStorage();

            var amountPerPage = this.element.data('per-page') || 3;
            var amountMobilePerPage = this.element.data('mobile-per-page') || 2;
            var isMobile = this.element.data('is-mobile');

            amountPerPage = (isMobile ? amountMobilePerPage : amountPerPage);

            var defaultOptions = {
                route: 'allt_frontend.user_tracking.last_visited',
                sliderSelector: '',
                loadingClass: 'is-slider-loading',
                amountPerPage: amountPerPage,
                perPage: amountPerPage * 2,
                isMobile: isMobile,
                sliderPrevBtnSelector: '[data-fcse-role="slide-prev-btn"]',
                sliderNextBtnSelector: '[data-fcse-role="slide-next-btn"]'
            };

            this.addOptions(defaultOptions, options);

            this._init();
        };

        LastVisitedHotels.prototype = $.extend({}, Object.create(OptionsMixin), {
            /**
             * Initializer
             * @private
             */
            _init: function() {

                if (!this.element.length) {
                    return;
                }
                if (!this._storage) {
                    this.element.hide();
                }
                var hotel = this.element.attr('data-persist-hotel');
                var visitedHotels = this._storage.getItem('visited_hotels');
                // var visitedHotelsMarkup = this._storage.getItem('visited_hotels_markup');
                var amountPerPage = this.option('amountPerPage');

                this.requestHandler.on('success', $.proxy(this._dataSuccessHandler, this));
                var routeParams = {
                    type: 'visited_hotels',
                    page: 1,
                    perPage: amountPerPage
                };
                // We send stored visited hotels to backend for rendering
                var params = {
                    hotel: hotel || null,
                    visitedHotels: visitedHotels || null
                };
                this._loadData(routeParams, params);

                // If hotel to persist
                /* if (hotel) {
                    this.requestHandler.on('success', $.proxy(this._dataSuccessHandler, this));
                    var routeParams = {
                        type: 'visited_hotels',
                        page: 1,
                        perPage: this.option('amountPerPage')
                    };
                    // We send stored visited hotels to backend for rendering
                    var params = {
                        hotel: hotel || null,
                        visitedHotels: visitedHotels || null
                    };
                    this._loadData(routeParams, params);
                } else if (visitedHotelsMarkup) {
                    this._injectMarkup(visitedHotelsMarkup);
                } else if (!visitedHotelsMarkup) {
                    this.topElement.hide();
                } */
            },

            /**
             * Loads slider data
             * @param routeParams
             * @private
             */
            _loadData: function(routeParams, params) {
                this.element.addClass(this.option('loadingClass'));
                this.requestHandler.cancel(this.option('route'));
                this.requestHandler.send(this.option('route'), params, routeParams, {method: 'POST'});
            },

            /**
             * Request success handler
             * @param data
             * @private
             */
            _dataSuccessHandler: function(data, requestData) {
                this.element.removeClass(this.option('loadingClass'));

                if (requestData && requestData.route == this.option('route')) {
                    if (data && data.html) {
                        this._injectMarkup(data.html);
                        if (this._storage && data.meta && data.meta.hotels) {
                            this._storage.setItem('visited_hotels', data.meta.hotels);
                            this._storage.setItem('visited_hotels_markup', data.html);
                        }
                        this.element.show();
                        this.topElement.show();
                    } else {
                        this.topElement.hide();
                    }
                }
            },

            /**
             * Injects markup to DOM
             * @param html
             * @private
             */
            _injectMarkup: function(html) {
                this.element.removeClass(this.option('loadingClass'));
                this.element.html(html);
                this._carouselElement = $('[data-fcse-role="carousel"]', this.element);
                this._carouselElement.carousel(0);
                this._carouselElement.on('slide.bs.carousel', $.proxy(this._loadImages, this));
                this._loadImages();
                this._lastPageIndex = $('.item', this.element).last().data('index');
            },

            /**
             * Lazy load of images
             * @param event
             * @private
             */
            _loadImages: function(event) {
                var self = this,
                    pageIndex = event ? $(event.relatedTarget).data('index') : 0,
                    startIndexFrom = pageIndex * this.option('perPage'),
                    range = _.range(startIndexFrom, (pageIndex + 1) * this.option('perPage')),
                    prevBtn = $(this.option('sliderPrevBtnSelector'), this.element).hide(),
                    nextBtn = $(this.option('sliderNextBtnSelector'), this.element).hide();

                (pageIndex === 0) ? prevBtn.hide() : prevBtn.show();
                (pageIndex === this._lastPageIndex) ? nextBtn.hide() : nextBtn.show();

                _.each(range, function(index) {
                    var itemElement = $('[data-hotel-index="' + index + '"]', self._carouselElement);
                    if (itemElement.length) {
                        LazyImage.loadImages(itemElement);
                    }
                });
            }
        });

        return LastVisitedHotels;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/lastvisited/lastVisitedHotelSlider.js